import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <img
              src="https://public.readdy.ai/ai/img_res/db28388e-1886-4a03-9ff8-7fbc590df92f.png"
              alt="株式会社マスター・マインド・グループ"
              className="h-10 w-auto object-contain object-left"
            />
            <p className="text-gray-500 text-sm leading-relaxed">
              大阪市北区を拠点に、企業の経営課題解決と持続的な成長を支援する経営コンサルティング会社です。
            </p>
            <div className="flex flex-col gap-1.5 text-sm text-gray-500">
              <span><i className="ri-map-pin-line mr-1.5 text-yellow-500" />〒530-0043 大阪府大阪市北区天満1丁目4-19 キオプラザ天満橋</span>
              <span><i className="ri-user-line mr-1.5 text-yellow-500" />代表者：小西　真平</span>
              <span><i className="ri-phone-line mr-1.5 text-yellow-500" />050-8896-2380</span>
              <span><i className="ri-mail-line mr-1.5 text-yellow-500" />keiri@master-mind-group.com</span>
              <span><i className="ri-calendar-line mr-1.5 text-yellow-500" />設立：平成22年4月8日</span>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex flex-col gap-3">
            <h4 className="text-gray-700 font-semibold text-sm mb-1">サイトマップ</h4>
            {[
              { label: 'ホーム', href: '#home' },
              { label: '会社概要', href: '#about' },
              { label: 'サービス', href: '#services' },
              { label: 'お問い合わせ', href: '#contact' },
            ].map((item) => (
              <a
                key={item.label}
                href={isHome ? item.href : `/${item.href}`}
                onClick={(e) => {
                  if (isHome) {
                    e.preventDefault();
                    scrollTo(item.href);
                  }
                }}
                className="text-gray-500 text-sm hover:text-yellow-600 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <Link to="/privacy-policy" className="text-gray-500 text-sm hover:text-yellow-600 transition-colors">
              プライバシーポリシー
            </Link>
          </div>

          {/* Services */}
          <div className="flex flex-col gap-3">
            <h4 className="text-gray-700 font-semibold text-sm mb-1">主なサービス</h4>
            {[
              '経営戦略策定',
              '組織開発・人材育成',
              '財務・収益改善',
              '業務プロセス改革',
              '新規事業開発',
              'リスクマネジメント',
              'SNS運用代行',
            ].map((s) => (
              <span key={s} className="text-gray-500 text-sm">{s}</span>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs">
            &copy; {new Date().getFullYear()} 株式会社マスター・マインド・グループ. All rights reserved.
          </p>
          <Link to="/privacy-policy" className="text-gray-400 text-xs hover:text-yellow-600 transition-colors">
            プライバシーポリシー
          </Link>
        </div>
      </div>
    </footer>
  );
}
